import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const seffnerConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Seffner Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Seffner, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_seffner',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Seffner',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Seffner Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the residential and rural 
     properties of <strong>Seffner</strong> with dependable, professional tree 
     care. This community on the eastern edge of Tampa has a mix of established 
     neighborhoods and larger lots where trees grow large and fast. When storm 
     season hits and those trees start threatening your home, fence, or vehicles, 
     our team responds with the equipment and experience to handle it right.`,

    `We specialize in <strong>dangerous tree removal and canopy management</strong> 
     large oak and pine removals, storm cleanup on residential and semi rural 
     properties, overhanging limbs near homes and outbuildings, and precision 
     trimming that eliminates hazards without over clearing your landscape. 
     We work efficiently and clean up completely.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Seffner</strong> and the surrounding 
     <strong>East Hillsborough</strong> area keeping your property 
     protected and your trees healthy through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Seffner, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Seffner = () => <LocationPage config={seffnerConfig} />;
export default Services_Seffner;
